import React, { useState, useEffect } from "react";
import "./PaymentScreen.css";
import "../CI/COD.css";
import { getRequest, postRequest, getHumanReadableDate, convertToINR } from "../../globalhelper/helper";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { v4 as uuidv4 } from "uuid";
import { CSVLink } from "react-csv";
import NewPaymentPopup from "./NewPaymentPopup";
import CancelIcon from "@mui/icons-material/Cancel";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FormControl, FormLabel, Accordion, AccordionDetails, AccordionSummary, Autocomplete, Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, Box, IconButton, TableFooter, TablePagination, TableContainer, DialogActions, Dialog, DialogTitle, DialogContent, Checkbox, Alert, AlertTitle, Tooltip, Pagination } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from "moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useDispatch } from "react-redux";
import { hideLoader, showAlert, showLoader } from "../../redux/Common/commonActions";
import { GetApp } from "@mui/icons-material";
import DialougeBox from "../VR2_Form_Rendering/DialougeBox";
const NewPaymentScreen = props => {
  const [formData, setFormData] = useState({
    company: "",
    periodMonth: moment().format("MMM-YYYY"),
    bank: "",
    transactionType: "",
    vendorType: "",
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().endOf("month").format("YYYY-MM-DD")
  });
  const [alert, setAlert] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  let dispatch = useDispatch();
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const [dropdown, setDropdown] = useState({
    billNumber: "",
    sendername: ""
  });
  const [filterData, setFilterData] = useState({
    fromDate: moment(),
    toDate: moment()
  });
  const [companyDetails, setCompanyDetails] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [paymentModeList, setPaymentModeList] = useState(["Internet Banking", "Credit Card"]);
  const [TDSDetails, setTDSDetails] = useState([]);
  const [dropdownBillNumber, setDropdownBillNumber] = useState([]);
  const [dropdownsendername, setDropdownsendername] = useState([]);
  const [completeDataFromDB, setCompleteDataFromDB] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tableDisplay, setTableDisplay] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [paymentScreen, setPaymentScreen] = useState(false);
  const [mainScreen, setMainScreen] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [amountPayable, setAmountPayable] = useState(0);
  const [showSpinner, setShowSpinner] = useState(false);
  const [paymentFileDownload, setPaymentFileDownload] = useState([]);
  const [selectedCheckBox, setSelectedCheckBox] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [popupTable, setPopupTable] = useState([]);
  const [dialog, setDialog] = useState(null);
  const [dateRange, setDateRange] = useState([]);
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [popupData, setPopupData] = useState({});
  const [billsForWF, setBillsForWF] = useState("");
  const [approverDetails, setApproverDetails] = useState([]);

  // API to get all the companies assigned to a user

  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`).then(response => {
      const responseData = response.res.data;
      console.log(responseData);
      const orgname = responseData.map(item => item.orgname);
      setCompanyDetails(responseData);
      setCompanyName(orgname);
      if (orgname.length === 1) {
        handleChange("company", orgname[0]);
      }
    }).catch(err => console.log(err));
    getRequest(`api/edureka/getTDSDetails`).then(({
      res
    }) => {
      setTDSDetails(res.data);
    }).catch(err => console.log(err));
  }, []);

  // Function to get the banks for the specified company

  useEffect(() => {
    if (formData.company === "" || formData.company === null) return;
    console.log(formData.company);
    const {
      orgid
    } = companyDetails.find(item => item.orgname === formData.company);
    console.log(companyDetails, "here", orgid);
    getRequest(`api/edureka/getBankList?orgid=${orgid}`).then(({
      res
    }) => {
      const responseData = res.data;
      const uniqueBanks = responseData.map(item => item.accountclass);
      setBankList(uniqueBanks);
    }).catch(err => {
      console.log(err);
    });
  }, [formData.company]);
  const getFilteredArray = async (value, key) => {
    const dropdown_array = value.map(val => val[key]);
    const filtered_dropdown_array = [...new Set(dropdown_array)];
    return filtered_dropdown_array.filter(item => item !== undefined && item !== "");
  };
  const handleChange = (name, value) => {
    if (name === "periodMonth") {
      let startDate = moment(value).startOf("month").format("YYYY-MM-DD");
      let endDate = moment(value).endOf("month").format("YYYY-MM-DD");
      setFormData(prevState => {
        return {
          ...prevState,
          [name]: value,
          startDate,
          endDate
        };
      });
      return;
    }
    setFormData(prevState => {
      return {
        ...prevState,
        [name]: value
      };
    });
  };

  // Handles couple of API calls to determine already paid bills and pending bills

  const handleSubmit = async () => {
    const {
      bank,
      transactionType,
      vendorType
    } = formData;
    try {
      dispatch(showLoader());
      const id = companyDetails.filter(item => item.orgname === formData.company);
      const companyid = id.map(item => item.orgid);
      Promise.all([getRequest(`api/edureka/getEdurekaPayment?vendortype=${vendorType}&orgid=${companyid[0]}&startDate=${formData.startDate}&endDate=${formData.endDate}&transType=${transactionType}`), getRequest(`api/edureka/alreadyPaidBillNumbers?orgid=${companyid[0]}`)]).then(async ([item, value]) => {
        const responseData = JSON.parse(item.res.data);
        const billNumbers = JSON.parse(value.res.data);
        console.log(responseData, "res", billNumbers, "bill");
        if (responseData.length === 0) {
          setAlert(<Box sx={{
            margin: "auto"
          }}>
            <Alert severity="warning">
              <AlertTitle>No Data Found</AlertTitle>
              There is no data to display at the moment.
            </Alert>
          </Box>);
          return;
        }
        setAlert(null);
        const distinctBillNumbers = billNumbers?.map(item => item.linkref) || [];
        console.log(distinctBillNumbers, "dist");
        // const filteredArray = responseData.filter(obj => !distinctBillNumbers.includes(obj.documentnumber))
        const filteredArray = responseData.filter(obj => obj.lc_payamount != 0);
        console.log(filteredArray);
        const billNumberList = await getFilteredArray(filteredArray, "documentnumber");
        const vendorNameList = await getFilteredArray(filteredArray, "sendername");
        setDropdownBillNumber(billNumberList);
        setDropdownsendername(vendorNameList);
        setCompleteDataFromDB(filteredArray);
        setTableData(filteredArray);
        setTableDisplay(filteredArray);
        setPaymentScreen(true);
      });
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(hideLoader());
    }
  };

  // Function to get createdby, modifiedby from Workflow

  useEffect(() => {
    if (completeDataFromDB.length > 0) {
      const distinctBillNumbers = completeDataFromDB.map(item => item.documentnumber);
      const billNosForQuerying = `('${distinctBillNumbers.join("', '")}')`;
      console.log(billNosForQuerying);
      console.log(distinctBillNumbers);
      setBillsForWF(billNosForQuerying);
    }
  }, [completeDataFromDB]);
  useEffect(() => {
    if (billsForWF.trim().length > 0) {
      postRequest(`api/edureka/getApproverForBills`, {
        item: billsForWF
      }).then(response => {
        console.log(response.res.data);
        const details = JSON.parse(response.res.data);
        setApproverDetails(details);
      }).catch(err => console.log(err));
    }
  }, [billsForWF]);
  const handleBack = () => {
    setMainScreen(true);
    setPaymentScreen(false);
    setSelectedCheckBox([]);
    setSelectAll(false);
  };
  const removeDuplicatesFromAnArrayOfObjects = (arr1, arr2, key) => {
    const result = [];
    const arr2Set = new Set(arr2.map(obj => obj[key]));
    console.log(arr2Set);
    for (const obj of arr1) {
      if (!arr2Set.has(obj[key])) {
        result.push(obj);
      }
    }
    return result;
  };

  // All the filtering logic goes here

  useEffect(() => {
    setPage(0);
    const filteredArray = completeDataFromDB.filter(item => (item.documentnumber === dropdown.billNumber || dropdown.billNumber === "" || dropdown.billNumber === null) && (item.sendername === dropdown.sendername || dropdown.sendername === "" || dropdown.sendername === null));
    const uniqueArray = removeDuplicatesFromAnArrayOfObjects(filteredArray, selectedRows, "documentnumber");
    setTableDisplay(uniqueArray);
  }, [dropdown.billNumber, dropdown.sendername]);
  const handleDropdownChange = (name, value) => {
    setDropdown(prevState => {
      return {
        ...prevState,
        [name]: value
      };
    });
  };

  // Display total amount payable

  useEffect(() => {
    const totalAmount = selectedRows.map(item => parseFloat(item.lc_payamount));
    console.log(totalAmount);
    const sum = totalAmount.reduce((acc, com) => acc + com, 0);

    setAmountPayable(Number(-1 * sum));
  }, [selectedRows]);

  // Handles remove functionality

  const handleRemove = item => {
    const updatedArray = selectedRows.filter(obj => obj.documentnumber !== item.documentnumber);
    const removeFromSelectedRow = selectedCheckBox.filter(selectedItem => selectedItem !== item.documentnumber);
    console.log(removeFromSelectedRow);
    setSelectedRows(updatedArray);
    setSelectedCheckBox(removeFromSelectedRow);
  };

  // Handles Reset

  const handleReset = () => {
    setTableData(completeDataFromDB);
    setDropdown({
      billNumber: "",
      sendername: ""
    });
    setFilterData({
      fromDate: "",
      toDate: ""
    });
    setDateRange([]);
    setSelectedRows([]);
    setSelectAll(false);
    setSelectedCheckBox([]);
  };

  // Makes API call to backend to create JSON in the specified format and calls schema

  const handleFileSubmit = async () => {
    try {
      console.log(selectedRows);
      setShowSpinner(true);
      const distinctVendorIDs = selectedRows.map(item => item.senderaccount);
      const joinedArr = `('${distinctVendorIDs.join("', '")}')`;
      console.log(joinedArr);

      // Gets bank details

      const response = await postRequest(`api/edureka/generatePaymentFile`, {
        item: joinedArr
      });
      const responseData = response.res.data;
      console.log(responseData, "responseData");
      const copyOfSelected = [...selectedRows];
      console.log(copyOfSelected, "copyOfSelected");
      const finalData = await joinTwoArrays(copyOfSelected, responseData, "senderaccount");
      console.log(finalData, "finalData");
      const setTransactionType = await processTransactionType(finalData);
      console.log(setTransactionType, "setTransactionType");
      const objectsNotPresent = await checkKeysPresence(setTransactionType);
      console.log(objectsNotPresent, "objectsNotPresent");
      if (objectsNotPresent.length) {
        setPopupTable(objectsNotPresent);
        setShowTable(true);
        setPaymentScreen(false);
        setShowSpinner(false);
      } else {
        const finalArr = await prepareFinalArray(setTransactionType);
        console.log(finalArr, "final");
        let response = await postPaymentSchema(finalArr);
        console.log(response);
        if (response.res.status === "error") {
          dispatch(showAlert("Oops something went wrong", "error"));
          setTimeout(() => {
            dispatch(hideLoader());
          }, 7000);
          return;
        }
        const uniqueList = await getReferenceNumber(finalArr);
        console.log(await JSON.parse(uniqueList), "res");
        const result = await JSON.parse(uniqueList);
        // const uniqueDocs = result.map(item => item)
        const includeReferenceNumber = async (arr1, arr2) => {
          return arr1.map(item1 => {
            const item2 = arr2.find(item2 => item2["linkref"] === item1["documentnumber"]);
            return {
              ...item1,
              ...{
                ...item2,
                orgaccountname: "SAJEEPA",
                paymentType: "VPAY",
                orgaccountnumber: "678770878",
                static: "M"
              }
            };
          });
        };
        const results = await includeReferenceNumber(setTransactionType, result);
        console.log(setTransactionType, results);
        uploadCSV(results, response.res.data);
        setMainScreen(true);
        setPaymentScreen(false);
        handleReset();
        handleSubmit();
        setShowSpinner(false);
      }
    } catch (err) {
      console.log(err);
      dispatch(showAlert("Oops something went wrong", "error"));
    } finally {
      setShowSpinner(false);
    }
  };
  const getReferenceNumber = async array => {
    const id = companyDetails.find(item => item.orgname === formData.company);
    const companyid = id.orgid;
    const billNumbers = array.map(item => item.documentreference);
    console.log(billNumbers);
    const request = {
      arr: billNumbers,
      orgid: companyid
    };
    const response = await postRequest(`api/edureka/getPaymentReferences`, request);
    console.log(response.res.data);
    return response.res.data;
  };
  const processTransactionType = responseData => {
    return responseData.map(item => {
      const hdfc = "hdfc";
      const bankName = item.bankname ? item.bankname.toLowerCase() : "";
      const transactiontype = bankName.includes(hdfc.toLowerCase()) ? "I" : "N";
      return {
        ...item,
        txnType: transactiontype,
        currentDate: moment().format("YYYY-MM-DD"),
        lc_payamount: item.Lc_FinalAmount * -1 || item.lc_payamount * -1,
        Lc_FinalAmount: item.Lc_FinalAmount * -1 || item.lc_payamount * -1
      };
    });
  };
  const checkKeysPresence = data => {
    const keysToCheck = ["accountholdername", "beneficiary", "accountnumber", "ifsccode", "bankname"];

    // 1. Objects missing required keys
    const missingKeys = data.filter(obj => keysToCheck.some(key => !(key in obj)));

    // 2. Objects with empty/falsy values
    const emptyValues = data.filter(obj => !obj.accountholdername || !obj.accountnumber || !obj.beneficiary || !obj.ifsccode || !obj.bankname);

    // Combine both
    let combined = missingKeys.length > 0 ? missingKeys : emptyValues;

    // Deduplicate by senderaccount
    combined = combined.filter((obj, index, self) => index === self.findIndex(t => t.senderaccount === obj.senderaccount));
    return combined;
  };
  const prepareFinalArray = data => {
    const id = companyDetails.find(item => item.orgname === formData.company);
    const companyid = id.orgid;
    return data.map(item => ({
      ...item,
      sendername: formData.company,
      receiveraccount: companyid,
      bankref: formData.bank,
      type: "Payment",
      orgid: companyid,
      documentreference: item.documentnumber
    }));
  };
  const postPaymentSchema = async finalArr => {
    try {
      const id = companyDetails.find(item => item.orgname === formData.company);
      const companyid = id.orgid;
      const request = {
        arr: finalArr,
        orgid: companyid,
        user: props.state.login.userData.USR_Email,
        vendorType: formData.vendorType,
        transType: formData.transactionType,
        bank: formData.bank
      };
      const response = await postRequest(`api/edureka/paymentSchema`, request);
      console.log(response);
      return response;
    } catch (error) {
      console.log(error);
    }
  };
  const uploadCSV = async (data, TransID) => {
    console.log(data, "csvdata");
    try {
      let headers;
      if (formData.bank.toLowerCase().includes("kotak")) {
        headers = ["orgaccountname", "paymentType", "paymentMode", "Doc", "add1", "currentDate", "add2", "orgaccountnumber", "Lc_FinalAmount", "static", "add3", "beneficiary", "add5", "ifsccode", "accountnumber"];
      }
      if (formData.company === "" || formData.company === null) return;
      console.log(formData.company);
      const {
        orgid
      } = companyDetails.find(item => item.orgname === formData.company);
      let response = await postRequest("api/vr2/uploadBankFile", {
        array: data,
        headers,
        TransID,
        orgid
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  };
  const joinTwoArrays = (arr1, arr2, key) => {
    return arr1.map(item1 => {
      const item2 = arr2.find(item => item[key] === item1[key]);
      return {
        ...item1,
        ...{
          ...item2,
          paymentMode: item2?.ifsccode && item2?.ifsccode?.includes("KKBK") && "IFT" || parseInt(Math.abs(item1.Lc_FinalAmount)) >= 200000 && "RGST" || "NEFT"
        }
      };
    });
  };
  const formatIndianNumber = x => {
    if (x == null) return "";
    let parts = x.toString().split(".");
    let integerPart = parts[0];
    let decimalPart = parts.length > 1 ? "." + parts[1] : "";
    let lastThree = integerPart.substring(integerPart.length - 3);
    let otherNumbers = integerPart.substring(0, integerPart.length - 3);
    if (otherNumbers !== "") {
      lastThree = "," + lastThree;
    }
    integerPart = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return integerPart + decimalPart;
  };
  const handlePopupTableChange = (item, e) => {
    const arrData = [...popupTable];
    const {
      name,
      value
    } = e.target;
    console.log(name, value);
    const objIndex = arrData.findIndex(val => val.documentnumber === item.documentnumber);
    console.log(objIndex);
    const tempArr = arrData[objIndex];
    const updatedArray = {
      ...tempArr,
      [name]: value
    };
    console.log(updatedArray);
    const finalArray = [...arrData.slice(0, objIndex), updatedArray, ...arrData.slice(objIndex + 1)];
    console.log(finalArray);
    setPopupTable(finalArray);
  };
  const handlePopupClose = () => {
    setPaymentScreen(true);
    setShowTable(false);
  };
  const handleVerification = async () => {
    try {
      setShowSpinner(true);
      const response = await postRequest("api/edureka/postVendorBankDetails", {
        dataArray: popupTable
      });
      console.log(response);
      if (response.res.status === "success") {
        setShowTable(false);
        handleFileSubmit();
        setPopupData([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setShowSpinner(false);
    }
  };
  async function getUserName(email) {
    const parts = email.split("@");
    const username = parts[0];
    if (username.includes(".")) {
      const userNameParts = username.split(".");
      const formattedUserName = userNameParts.map(item => {
        return item.charAt(0).toUpperCase() + item.slice(1);
      }).join(" ");
      return formattedUserName;
    } else {
      return username.charAt(0).toUpperCase() + username.slice(1);
    }
  }
  async function getUserDetails(billNumber) {
    const filteredDetails = approverDetails.filter(item => item.documentnumber === billNumber);
    if (filteredDetails.length === 0) return "";
    const [modifiedByUser, createdByUser] = await Promise.all([getUserName(filteredDetails[0].modifiedby), getUserName(filteredDetails[0].createdby)]);
    return {
      approver: modifiedByUser,
      validator: createdByUser
    };
  }
  useEffect(() => {
    const fetchFileDetails = async () => {
      const fileData = await Promise.all(selectedRows.map(async item => {
        const userDetails = await getUserDetails(item.documentnumber);
        return {
          "Vendor Name": item.sendername,
          "Invoice Number": item.documentreference,
          "Validated By": userDetails.validator,
          "Approved By": userDetails.approver,
          "Invoice Date": item.documentdate,
          "Due Date": item.postingdate,
          Basic: item.Lc_BaseValue,
          "Total GST": item.Lc_TaxAmount,
          TDS: item.Lc_WHTaxAmount,
          "Net Amount Payable": Number(item.AmtInLocalCurrency) * -1,
          "P&L LedgerName": item.Ledger,
          "Details/Remarks": `Bill from ${item.sendername} for the period from ${item.FPF} to ${item.FPT} towards ${item.Ledger}`
        };
      }));
      setPaymentFileDownload(fileData);
    };
    fetchFileDetails();
  }, [selectedRows]);
  const handleFilterDateChange = e => {
    const {
      name,
      value
    } = e.target;
    console.log(name);
    console.log(value);
    setFilterData(prev => {
      return {
        ...prev,
        [name]: value
      };
    });
  };
  const getDatesInBetween = (startDate, endDate) => {
    let dates = [];
    let currentDate = moment(startDate);
    const lastDate = moment(endDate);
    while (currentDate <= lastDate) {
      dates.push(currentDate.format("YYYY-MM-DD"));
      currentDate = currentDate.clone().add(1, "days");
    }
    return dates;
  };

  // Find the dates between the given range

  // useEffect(() => {
  //   const { fromDate, toDate } = filterData

  //   console.log(fromDate, toDate)

  //   if (new Date(fromDate) > new Date(toDate)) {
  //     dispatch(showAlert('From date must be lesser than To date'))
  //   } else if (fromDate && toDate) {
  //     const datesBetween = getDatesInBetween(fromDate, toDate)

  //     setDateRange(datesBetween)

  //     console.log(datesBetween)
  //   }
  // }, [filterData.toDate, filterData.fromDate])

  // useEffect(() => {
  //   setFilterData(prev => {
  //     return { ...prev, toDate: formData.transactionDate }
  //   })
  // }, [formData.transactionDate])

  const handleSubmission = finalData => {
    console.log(finalData);
    setShowAddPopup(false);
    const filteredArray = [...selectedRows];
    const indexToReplace = filteredArray.findIndex(obj => obj.documentnumber === finalData.documentnumber);
    filteredArray.splice(indexToReplace, 1, finalData);

    // const filtered = filteredArray.filter(obj => obj.documentnumber !== finalData.documentnumber)

    // const finalArray = [...filtered, finalData]

    // setTableData(updatedArray)
    setSelectedRows(filteredArray);
  };
  const handleCheckboxChange = item => {
    const selectedIndex = selectedCheckBox.indexOf(item.documentnumber);
    let updatedSelected = [...selectedCheckBox];
    if (selectedIndex === -1) {
      updatedSelected.push(item.documentnumber);
    } else {
      updatedSelected.splice(selectedIndex, 1);
    }
    setSelectedCheckBox(updatedSelected);
  };
  const handleSelectAll = () => {
    const allDocNumbers = tableData.map(item => item.documentnumber);
    if (selectAll) {
      setSelectedCheckBox([]);
    } else {
      setSelectedCheckBox(allDocNumbers);
    }
    setSelectAll(!selectAll);
  };
  useEffect(() => {
    const updatedArray = completeDataFromDB.filter(item => selectedCheckBox.includes(item.documentnumber));
    console.log(updatedArray);
    console.log(selectedRows);
    const finalArray = updatedArray.map(item => {
      return {
        ...item,
        Lc_FinalAmount: item.lc_payamount,
        percentage: 100,
        accountinglf: "payment"
      };
    });

    // const existingList = [...selectedRows, ...finalArray]

    // console.log(existingList)

    console.log(finalArray);
    setSelectedRows(finalArray);
  }, [selectedCheckBox]);
  const handleTDSValues = (value, id) => {
    const updatedArray = selectedRows.map(item => {
      if (item.documentnumber === id) {
        return {
          ...item,
          sectionname: value.tdsledgername,
          percentageoftds: parseInt(value.percentageoftds),
          accountinglf: value.accountinglf
        };
      }
      return item;
    });
    console.log(parseInt(value.percentageoftds));
    setSelectedRows(updatedArray);
  };
  const handlePaymentTypeChange = item => {
    setPopupData(item);
    setShowAddPopup(true);
  };
  return <>
    {dialog}
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
        <Typography variant="h6">Payment Preparation</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={1} sm={2} md={2}>
            <Autocomplete size="small" fullWidth value={formData?.company || null} options={companyName || []} onChange={(event, newValue) => handleChange("company", newValue)} renderInput={params => <TextField {...params} label="Company" variant="outlined" name="Company" />} />
          </Grid>
          <Grid item xs={1} sm={2} md={1.5}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker label="Period Month" value={formData.periodMonth} inputFormat="MMM-YYYY" minDate={moment().subtract(1, "year").startOf("year")} maxDate={moment().endOf("year")} views={["year", "month"]} onChange={newValue => handleChange("periodMonth", newValue)} renderInput={params => <TextField fullWidth size="small" {...params} />} />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={1} sm={2} md={2}>
            <Autocomplete size="small" fullWidth value={formData?.bank || null} options={bankList || []} onChange={(event, newValue) => handleChange("bank", newValue)} renderInput={params => <TextField {...params} label="Bank" variant="outlined" name="bank" />} />
          </Grid>

          <Grid item xs={1} sm={2} md={2}>
            <Autocomplete size="small" fullWidth value={formData?.transactionType || null} options={["BillExtract", "EmployeeReimbursement", "PettyCash"] || []} onChange={(event, newValue) => handleChange("transactionType", newValue)} renderInput={params => <TextField {...params} label="Transaction Type" variant="outlined" name="transactionType" />} />
          </Grid>

          <Grid item xs={1} sm={2} md={2}>
            <Autocomplete size="small" fullWidth value={formData?.vendorType || null} options={["Domestic", "International"] || []} onChange={(event, newValue) => handleChange("vendorType", newValue)} renderInput={params => <TextField {...params} label="Vendor Type" variant="outlined" name="vendorType" />} />
          </Grid>

          <Grid item>
            <Button variant="contained" color="primary" disabled={Object.values(formData).some(item => item === "" || item === null)} onClick={handleSubmit}>
              Submit
            </Button>
            &nbsp;
            <Button variant="contained" color="error" onClick={handleReset}>
              Reset
            </Button>
            &nbsp;
            <Button variant="contained" color="warning" onClick={handleBack}>
              Back
            </Button>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>

    {tableData.length > 0 && <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Transaction Date</TableCell>
              <TableCell>Bank</TableCell>
              {/* <TableCell>Bank Account</TableCell> */}
              <TableCell>Transaction Type</TableCell>
              <TableCell>Vendor Type</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                {getHumanReadableDate(formData.transactionDate)}
              </TableCell>
              <TableCell>{formData.bank}</TableCell>
              {/* <TableCell>{formData.accountClass}</TableCell> */}
              <TableCell>{formData.transactionType}</TableCell>
              <TableCell>{formData.vendorType}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
          <Typography variant="h6">Filter</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={1} sm={2} md={2}>
              <Autocomplete size="small" fullWidth value={dropdown?.sendername || null} options={dropdownsendername || []} onChange={(event, newValue) => handleDropdownChange("sendername", newValue)} renderInput={params => <TextField {...params} label="Vendor Name" variant="outlined" />} />
            </Grid>

            <Grid item xs={1} sm={2} md={2}>
              <Autocomplete size="small" fullWidth value={dropdown?.billNumber || null} options={dropdownBillNumber || []} onChange={(event, newValue) => handleDropdownChange("billNumber", newValue)} renderInput={params => <TextField {...params} label="Bill Number" variant="outlined" />} />
            </Grid>

            {/* <Grid item xs={1} sm={2} md={2}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label='Acc. Date From'
                      value={filterData.fromDate}
                      inputFormat='DD-MM-YYYY'
                      minDate={moment().subtract(1, 'year').startOf('year')}
                      maxDate={moment().endOf('year')}
                      views={['year', 'month', 'day']}
                      onChange={newValue => handleChange('fromDate', newValue)}
                      renderInput={params => (
                        <TextField fullWidth size='small' {...params} />
                      )}
                    />
                  </LocalizationProvider>
                 </Grid>
                  <Grid item xs={1} sm={2} md={2}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label='Acc. Date To'
                      value={filterData.toDate}
                      inputFormat='DD-MM-YYYY'
                      minDate={moment().subtract(1, 'year').startOf('year')}
                      maxDate={moment().endOf('year')}
                      views={['year', 'month', 'day']}
                      onChange={newValue => handleChange('toDate', newValue)}
                      renderInput={params => (
                        <TextField fullWidth size='small' {...params} />
                      )}
                    />
                  </LocalizationProvider>
                 </Grid> */}

            {selectedRows.length > 0 ? <>
              <Grid item xs={1} sm={2} md={2}>
                <FormControl fullWidth>
                  <FormLabel>Total Amount Payable</FormLabel>
                  <Typography variant="h6" component="div">
                    <strong>{convertToINR(amountPayable)}</strong>
                  </Typography>
                </FormControl>
              </Grid>

              <Grid item xs={1} sm={2} md={2}>
                <Button sx={{
                  marginRight: "10px"
                }} onClick={handleFileSubmit} variant="contained" color="warning" disabled={showSpinner}>
                  {showSpinner ? "Loading..." : "Process"}
                </Button>

                <CSVLink filename="Payments.csv" sx={{
                  textDecoration: "none"
                }} data={paymentFileDownload}>
                  <Button color="success" variant="contained">
                    <FileDownloadRoundedIcon />
                  </Button>
                </CSVLink>
              </Grid>
            </> : null}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </>}

    {showAddPopup ? <NewPaymentPopup data={popupData} handleClose={() => {
      setShowAddPopup(false);
    }} onSubmit={handleSubmission} /> : null}

    {selectedRows.length > 0 && <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Remove</TableCell>
              {/* <TableCell>Transaction Type</TableCell> */}
              <TableCell>Edit</TableCell>
              {Object.keys(selectedRows[0]).map(item => <TableCell>{item}</TableCell>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {selectedRows.map((item, index) => {
              return <TableRow key={item.documentnumber}>
                <TableCell>
                  <Button variant="link" onClick={() => handleRemove(item, index)}>
                    <CancelIcon color="error" />
                  </Button>
                </TableCell>
                <TableCell>
                  <Button variant="link" onClick={() => handlePaymentTypeChange(item, index)}>
                    <EditOutlinedIcon color="success" />
                  </Button>
                </TableCell>
                {Object.keys(selectedRows[0]).map(key => <TableCell>
                  {key === "paymentrefs" && <Tooltip title={item[key]}>
                    {item[key]?.slice(0, 20)}...
                  </Tooltip> || key === "sectionname" && (item[key] === "" || item[key] === null) && <Autocomplete size="small" sx={{
                    width: 200
                  }} value={TDSDetails?.find(opt => opt.tdsledgername === item[key]) || null} options={TDSDetails || []} getOptionLabel={option => option?.tdsledgername || ""} isOptionEqualToValue={(option, value) => option?.tdsledgername === value.tdsledgername} onChange={(event, newValue) => {
                    setDialog(<DialougeBox message={`Are you sure ${newValue?.tdsledgername} is the ledger name and the TDS Percentage is ${newValue?.percentageoftds}?`} status={"warning"} operation={{
                      title: "Yes As Payment Recepit",
                      functionality: () => {
                        handleTDSValues({
                          ...newValue,
                          accountinglf: "payment"
                        }, item["documentnumber"]);
                        setDialog(null);
                      }
                    }} operation1={{
                      title: "Yes As Journal",
                      functionality: () => {
                        handleTDSValues({
                          ...newValue,
                          accountinglf: "journal"
                        }, item["documentnumber"]);
                        setDialog(null);
                      }
                    }} onClose={() => setDialog(null)} />);
                  }} renderInput={params => <TextField {...params} label="TDS" variant="outlined" />} /> || item[key]}
                </TableCell>)}
              </TableRow>;
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>}

    {tableData.length > 0 ? <>
      <Box align="right" sx={{
        m: 2,
        display: "flex",
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 2
      }}>
        <>
          <Pagination count={Math.ceil(tableData.length / rowsPerPage)} page={page + 1} onChange={(event, newPage) => {
            handleChangePage(event, newPage - 1);
          }} variant="outlined" shape="rounded" showFirstButton showLastButton />
          &nbsp;
          <CSVLink size="sm" filename={`payments_${moment().format("YYYY-MM-DD_HH-mm-ss")}.csv`} data={tableData}>
            <Button variant="contained" color="success">
              <GetApp />
            </Button>
          </CSVLink>
        </>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Checkbox checked={selectAll} onClick={handleSelectAll} />
              </TableCell>
              {Object.keys(tableData[0]).map((key, index) => <TableCell key={index}>{key}</TableCell>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableDisplay.length > 0 && (rowsPerPage > 0 ? tableDisplay.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : tableDisplay).map((item, index) => {
              return <TableRow key={item.documentnumber}>
                <TableCell>
                  <Checkbox checked={selectedCheckBox.includes(item.documentnumber)} onClick={() => handleCheckboxChange(item)} />
                </TableCell>
                {Object.keys(item).map(key => <TableCell>
                  {key === "paymentrefs" && <Tooltip title={item[key]}>
                    {item[key] && `${item[key]?.slice(0, 20)}...`}
                  </Tooltip> || item[key]}
                </TableCell>)}
              </TableRow>;
            }) || <TableRow>
                <TableCell colSpan={Object.keys(tableData[0]).length / 2} align="center">
                  <Alert severity="error" variant="outlined">
                    No matching records found. Please adjust your search
                    criteria.
                  </Alert>
                </TableCell>
              </TableRow>}
          </TableBody>
        </Table>
      </TableContainer>
    </> : <>{alert}</>}
    <Dialog open={showTable} maxWidth="lg" fullWidth>
      <DialogTitle sx={{
        fontSize: "1rem"
      }}>
        Please fill the missing values to continue
      </DialogTitle>
      <DialogContent>
        <Table>
          <TableHead>
            <TableRow>
              {(popupTable && popupTable.length > 0 ? Object.keys(popupTable[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
                textAlign: 'left'
              }}><b>{key}</b></TableCell>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {(popupTable || []).map((row, rowIndex) => <TableRow key={rowIndex}>
              {Object.entries(row || {}).map(([key, val], valIndex) => {
                let displayVal = val;
                if (typeof val === 'number' && !Number.isInteger(val)) {
                  displayVal = val.toFixed(2);
                } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                  displayVal = parseFloat(val).toFixed(2);
                } else if (typeof val === 'boolean') {
                  displayVal = val ? 'Yes' : 'No';
                } else if (val === null || val === undefined) {
                  displayVal = '';
                } else if (typeof val === 'object') {
                  displayVal = JSON.stringify(val);
                }
                return <TableCell key={valIndex} sx={{
                  textAlign: 'left'
                }}>
                  {String(displayVal)}
                </TableCell>;
              })}
            </TableRow>)}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions sx={{
        display: "flex",
        justifyContent: "center"
      }}>
        <Button variant="contained" color="error" onClick={handlePopupClose}>
          Back
        </Button>
        <Button variant="contained" color="success" onClick={handleVerification} disabled={showSpinner || popupTable.some(item => item.beneficiary === "" || item.accountholdername === "" || item.accountnumber === "" || item.ifsccode === "" || item.bankname === "" || item.beneficiary === null || item.accountholdername === null || item.accountnumber === null || item.ifsccode === null || item.bankname === null)}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  </>;
};
function mapStateToProps(state) {
  return {
    state
  };
}
export default connect(mapStateToProps)(NewPaymentScreen);